import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoimagicataxi() {



const cardData = {
  keyword: "Pune to Imagica Taxi",
  heading: "Lotus Cab: Pune to Imagica Taxi",

  headingDescription:
    "Lotus Cab offers reliable and affordable Pune to Imagica Taxi service designed for families, friends, corporate groups, and weekend travelers looking for a fun-filled trip to Imagicaa Theme Park. Located near Khopoli, Imagicaa is one of India’s most popular amusement destinations, and a comfortable road journey makes the experience even better. Our Pune to Imagica cab service includes well-maintained AC sedan and SUV vehicles driven by professional, background-verified chauffeurs who ensure safe highway driving and punctual arrival. Whether you require a one-way drop, same-day return cab, or round-trip package, we provide flexible travel options at transparent per-kilometer pricing. The Mumbai-Pune Expressway route ensures a smooth and scenic ride, and our drivers are experienced with the safest and fastest routes. With easy online booking, doorstep pickup anywhere in Pune, and 24/7 customer support, Lotus Cab guarantees a stress-free, comfortable, and memorable Pune to Imagica taxi experience.",

  top: "Top Attractions at Imagicaa with Lotus Cab",

  topPlaces: [
    {
      title: "Imagicaa Theme Park",
      description:
        "Imagicaa Theme Park is one of India’s most thrilling amusement parks offering world-class rides, roller coasters, water attractions, and family entertainment. It is the primary reason travelers book Pune to Imagica taxi service for weekend and holiday trips. With exciting attractions like Nitro, Scream Machine, and themed rides for kids, the park caters to all age groups. A comfortable AC cab ensures you arrive relaxed and ready for adventure. Lotus Cab provides safe and convenient round-trip service for families and groups."
    },
    {
      title: "Imagicaa Water Park",
      description:
        "Imagicaa Water Park offers refreshing water slides, wave pools, and lazy rivers perfect for beating the heat. Families and corporate groups often book Pune to Imagica cab service for summer outings. Our comfortable sedan and SUV vehicles provide smooth travel via expressway routes. Spacious seating and luggage support ensure hassle-free transportation for swimwear and essentials."
    },
    {
      title: "Imagicaa Snow Park",
      description:
        "The Snow Park at Imagicaa gives visitors a winter experience with snow activities and themed attractions. Travelers prefer AC taxi service for comfortable travel before enjoying the cold indoor environment. Lotus Cab ensures timely arrival and flexible pickup timing for same-day return trips."
    },
    {
      title: "Nitro Roller Coaster",
      description:
        "Nitro is one of India’s largest roller coasters and a major attraction at Imagicaa. Adventure enthusiasts book Pune to Imagica taxi service for thrilling experiences. Our professional drivers ensure smooth and safe highway travel, allowing you to enjoy your adventure without travel stress."
    },
    {
      title: "Imagicaa House of Stars",
      description:
        "House of Stars is a popular entertainment zone featuring Bollywood-themed attractions. Families and kids love this indoor activity area. Comfortable AC cab travel enhances the overall experience of your theme park trip."
    },
    {
      title: "Alibaba Aur 40 Chorr Ride",
      description:
        "This family-friendly themed ride is perfect for children and group fun. Parents often book family trip taxi from Pune to Imagica for a safe and comfortable journey. Lotus Cab offers round-trip convenience."
    },
    {
      title: "Imagicaa Restaurants & Dining",
      description:
        "Imagicaa offers multiple dining options including themed restaurants and food courts. Travelers prefer flexible taxi booking to enjoy meals without rushing. Our same-day return cab options allow flexible scheduling."
    },
    {
      title: "Expressway Scenic Drive",
      description:
        "The Mumbai-Pune Expressway drive towards Imagicaa is scenic and smooth. Lotus Cab provides comfortable highway vehicles with experienced drivers ensuring safe travel throughout the journey."
    }
  ],

  services: [
    {
      name: "Pune to Imagicaa Taxi",
      description:
        "Book Pune to Imagicaa taxi with Lotus Cab for a comfortable and reliable theme park journey. We provide AC sedan and SUV vehicles suitable for families and groups. Our drivers are trained for safe highway travel via expressway routes. Transparent per-km pricing ensures no hidden charges. Flexible one-way and round-trip options available."
    },
    {
      name: "Pune to Imagica Cab Service",
      description:
        "Professional cab service from Pune to Imagica with punctual pickup and smooth travel. Ideal for weekend trips, school outings, and family vacations. Well-maintained vehicles with comfortable seating provided."
    },
    {
      name: "Pune to Imagica One Way Cab",
      description:
        "Affordable one-way drop taxi from Pune to Imagica where you pay only for single-side travel. Perfect for travelers planning overnight stays."
    },
    {
      name: "Pune to Imagica Round Trip Taxi",
      description:
        "Convenient round-trip taxi service with flexible return timing. Ideal for same-day return after enjoying rides and attractions."
    },
    {
      name: "Family Trip Taxi Pune to Imagica",
      description:
        "Spacious and comfortable taxi options suitable for family outings. AC vehicles and professional drivers ensure relaxed travel."
    },
    {
      name: "Corporate Outing Cab Imagica",
      description:
        "Reliable taxi service for corporate team outings and company events at Imagicaa. Multiple vehicle options available."
    },
    {
      name: "Affordable Pune to Imagica Cab",
      description:
        "Budget-friendly taxi service with competitive per-km rates and transparent billing structure."
    },
    {
      name: "Online Cab Booking Pune to Imagica",
      description:
        "Easy online booking with instant confirmation and 24/7 customer support assistance."
    }
  ],

  tableData: [
    ["Pune to Imagicaa Taxi", "Pune to Imagica Cab Service"],
    ["Pune to Imagica One Way Cab", "Pune to Imagica Round Trip Taxi"],
    ["Affordable Pune to Imagica Cab", "Luxury Taxi Pune to Imagica"],
    ["SUV Cab Pune to Imagica", "Family Trip Taxi Pune to Imagica"],
    ["Weekend Trip Cab Pune to Imagica", "Online Cab Booking Pune to Imagica"],
    ["Same Day Return Cab Imagica", "Corporate Outing Cab Imagica"],
    ["AC Taxi Pune to Imagica", "Best Cab Service Pune to Imagica"]
  ],

  whychoose: [
    { WhyChooseheading: "Safe Highway Travel", WhyChoosedescription: "Experienced drivers ensure smooth and safe expressway travel with proper route knowledge and defensive driving skills." },
    { WhyChooseheading: "Transparent Pricing", WhyChoosedescription: "Clear per-kilometer fare calculation with no hidden charges or last-minute surprises." },
    { WhyChooseheading: "Comfortable AC Vehicles", WhyChoosedescription: "Clean, well-maintained air-conditioned vehicles for relaxed family and group travel." },
    { WhyChooseheading: "Flexible Trip Options", WhyChoosedescription: "One-way, round-trip, and same-day return packages available for convenience." },
    { WhyChooseheading: "Ideal for Family & Kids", WhyChoosedescription: "Spacious seating and safe driving suitable for children and senior citizens." },
    { WhyChooseheading: "Corporate Group Travel", WhyChoosedescription: "Perfect taxi solution for corporate outings and team-building events." },
    { WhyChooseheading: "Doorstep Pickup", WhyChoosedescription: "Pickup available anywhere in Pune including residential areas and IT parks." },
    { WhyChooseheading: "24/7 Booking Support", WhyChoosedescription: "Round-the-clock assistance for bookings, schedule changes, and travel queries." }
  ]
};

const faqData = [
  { question: "How far is Imagicaa from Pune?", answer: "Imagicaa is approximately 90–100 km from Pune via Mumbai-Pune Expressway and takes around 2–2.5 hours depending on traffic." },
  { question: "Is same-day return taxi available?", answer: "Yes, Lotus Cab provides same-day return Pune to Imagica taxi service with flexible return timing." },
  { question: "Are SUV vehicles available?", answer: "Yes, SUV cab options are available for larger families and group travel." },
  { question: "Is one-way drop service available?", answer: "Yes, you can book one-way drop taxi if you plan overnight stay." },
  { question: "Are drivers experienced?", answer: "Yes, all drivers are professional and experienced in highway driving." },
  { question: "Is pricing transparent?", answer: "Yes, per-km pricing is transparent with clear billing." },
  { question: "Can corporate groups book taxis?", answer: "Yes, corporate outing taxi packages are available." },
  { question: "Is online booking available?", answer: "Yes, instant online booking is available." },
  { question: "Is AC taxi provided?", answer: "Yes, fully air-conditioned vehicles are provided." },
  { question: "Is customer support available 24/7?", answer: "Yes, round-the-clock support is available for assistance." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Mehta",
    feedback:
      "Booked Lotus Cab for Pune to Imagica family trip. The driver was punctual, the car was clean, and the ride via expressway was smooth and comfortable. Highly recommended for weekend outings.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Priya Kulkarni",
    feedback:
      "Used round-trip taxi service for Imagica. Transparent pricing and very professional driver. It made our group outing stress-free and enjoyable.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Booked corporate outing cab to Imagica for our team. Excellent coordination and comfortable vehicles. Will book again.",
    rating: 5
  }
];











































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Imagica Taxi",
  "image": "https://lotuscab.com/assets/images/pune-to-imagica-taxi.jpg", 
  "description": "Lotus Cab offers taxi services from Pune to Imagicaa for one-way, round trip, weekend trips, corporate outings, and family travel. Choose from luxury, SUV, and AC cabs with professional drivers, same-day return options, and convenient online booking for safe and comfortable travel.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-imagica-taxi"
  }
};







  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Pune to Imagica Taxi | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book taxi from Pune to Imagicaa with Lotus Cab. One-way, round trip, weekend & corporate trips. Luxury, SUV & AC cabs available. Online booking & same-day return. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Imagicaa Taxi, Pune to Imagica Cab Service, Pune to Imagica One Way Cab, Pune to Imagica Round Trip Taxi, Affordable Pune to Imagica Cab, Luxury Taxi Pune to Imagica, SUV Cab Pune to Imagica, Family Trip Taxi Pune to Imagica, Weekend Trip Cab Pune to Imagica, Online Cab Booking Pune to Imagica, Same Day Return Cab Imagica, Corporate Outing Cab Imagica, AC Taxi Pune to Imagica, Best Cab Service Pune to Imagica" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/41.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoimagicataxi;